import { LocationManager } from '@shared/app/scripts/services/location-manager';
import { Persist } from '@core/app/scripts/services/persist';

/*
 * Service articleInfoInit
 */
angular
  .module('posApp')
  .factory(
    'articleInfoInit',
    (
      $log: ng.ILogService,
      locationManager: LocationManager,
      persist: Persist,
    ) => {
      const articleInfoInit = {
        shops: [],
      };

      /*
       * Generate warehouse dropdown selection
       */
      function createShopFilter() {
        articleInfoInit.shops = [];

        let checked = false;
        for (const wareHouse in locationManager.all) {
          checked =
            locationManager.current.name == locationManager.all[wareHouse].name
              ? true
              : false;

          articleInfoInit.shops.push({
            name: locationManager.all[wareHouse].name,
            id: locationManager.all[wareHouse].wh,
            checked: checked,
          });
        }
      }

      if (persist.get('posArticleInfoShops')) {
        try {
          articleInfoInit.shops = JSON.parse(
            persist.get('posArticleInfoShops'),
          );
          //Check that shops object has ids. In 6.4 and before ids were not present
          if (articleInfoInit.shops && articleInfoInit.shops.length) {
            for (const s in articleInfoInit.shops) {
              if (!articleInfoInit.shops[s].id) {
                createShopFilter();
                break;
              }
            }
          }

          if (
            articleInfoInit.shops &&
            articleInfoInit.shops.length &&
            articleInfoInit.shops.length != locationManager.all.length
          ) {
            //Check if the persisted warehouses are a different length than the current warehouses
            //It could happen that a warehouse has been created or removed POS-249
            createShopFilter();
          }
        } catch (e) {
          $log.error('[ArticleInfo] Cannot parse saved shop filter', e);
          createShopFilter();
        }
      } else {
        createShopFilter();
      }

      return articleInfoInit;
    },
  );
